import { Page, Text, View, Document } from '@react-pdf/renderer';
import React from 'react';
import styles from './styles';

type CatalogItem = {
  id: number;
  id_ref: number;
  description: string;
  value: number;
  valueFormatted: string;
  reference: string;
};

interface Props {
  data: CatalogItem[];
}

function CatalogPDF({ data }: Props): React.ReactElement {
  return (
    <Document>
      <Page size="A4" wrap style={styles.page}>
        <View style={styles.tableHeader}>
          <Text style={[styles.tableCellHeader, { width: '15%' }]}>ID</Text>
          <Text style={[styles.tableCellHeader, { width: '50%' }]}>
            Descrição
          </Text>
          <Text style={[styles.tableCellHeader, { width: '20%' }]}>
            Referência
          </Text>
          <Text style={[styles.tableCellHeader, { width: '15%' }]}>Valor</Text>
        </View>
        <View style={styles.tableContent}>
          {data.map((catalogItem, index) => (
            <View
              key={catalogItem.id}
              wrap={false}
              style={[styles.row, index % 2 === 0 ? styles.colorRow : {}]}
            >
              <Text style={{ width: '15%' }}>{catalogItem.id_ref}</Text>
              <Text style={{ width: '50%' }}>{catalogItem.description}</Text>
              <Text style={{ width: '20%' }}>{catalogItem.reference}</Text>
              <Text style={{ width: '15%' }}>{catalogItem.valueFormatted}</Text>
            </View>
          ))}
          <View style={styles.bar} />
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
}

export default CatalogPDF;
